export const GRID_BATCH_SIZE_S = 2;
export const GRID_BATCH_SIZE_L = 3;
export const SCREEN_WIDTH_BREAKPOINT = 1024;
